import { API, axiosInstance } from "lib";

export const getConsignorDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: data?.limit ? data?.limit : 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_consignor_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getConsignorLocationDropdownListData = (data = {}) => {
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `consignor_location_for_dropdown`, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getUnitDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_unit_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getConsigneeDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_consignee_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getBranchDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_branch_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getSupplierDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_supplier_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getContractDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_contract_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getZoneDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_zone_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getLrTemplateDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_LRtemplate_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getPlanResponseApi = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.PLAN + `plan_responses_list`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getFuelApi = ({limit=1000,offset=1,...data}) => {
  let payload = {
    ...data,
    limit: limit,
    offset: offset,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_fuelstation_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getComapnyUser = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_company_users_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getAddressBookDropdownListData = (data = {}) => {
  let payload = {
    ...data,
    limit: 1000,
    offset: 1,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_addressbook_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getAddressBookDropdownListData2 = (data = {}) => {

  return axiosInstance
    .post(
      API.COMMON_DROPDOWN + `get_addressbook_for_dropdown`, data)
    .then((response) => {

      return response.data;
    })
    .catch((error) => {
      return error?.response?.data
    });
};

export const getDriverDropdownListData = ({limit=1000,offset=1,...data}) => {
  let payload = {
    ...data,
    limit: limit,
    offset: offset,
  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_driver_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};


export const getConsignorDropdownListData2 = (data = {}) => {
  let payload = {
    ...data,

  };
  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_consignor_for_dropdown`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getBranchListApi = (data = {}) => {

  return axiosInstance
    .post(API.COMMON_DROPDOWN + `get_branch_for_dropdown`, data)
    .then((response) => {

      return response.data;
    })
    .catch((error) => {
      return error?.response?.data
    });
};